export default {
    schema: {
        type: Object,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/TreeListDataSourceProps.js